import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs/Subscription';
import { AdminService } from '../../../../../services/admin.service';
import { NumberValidationService, ValidationResult } from './services/number-validation.service';
import { EditNumberResult } from './models/edit-number-result.model';
import { VALIDATION_MESSAGES, MODAL_DISMISS_REASONS } from './constants/validation.constants';

@Component({
  selector: 'app-edit-standard-number-popup',
  templateUrl: './edit-standard-number-popup.component.html',
  styleUrls: ['./edit-standard-number-popup.component.css'],
  providers: [NumberValidationService]
})
export class EditStandardNumberPopupComponent implements OnInit, OnDestroy {
  currentNumber = '';
  newNumber = '';
  standardId = '';
  isLoading = false;
  errorMessage = '';
  successMessage = '';
  private subscription: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    private adminService: AdminService,
    private validationService: NumberValidationService
  ) {}

  ngOnInit(): void {
    this.newNumber = this.currentNumber;
  }

  initParams(standardId: string, currentNumber: string): void {
    this.standardId = standardId;
    this.currentNumber = currentNumber;
    this.newNumber = currentNumber;
  }

  onNumberChange(): void {
    this.resetMessages();
    
    const trimmedNumber = this.getTrimmedNumber();
    const validation = this.validationService.validateNumber(trimmedNumber);
    
    if (!validation.isValid) {
      this.errorMessage = validation.message || '';
      return;
    }

    if (this.isNumberUnchanged(trimmedNumber)) {
      this.successMessage = VALIDATION_MESSAGES.NUMBER_IS_UNIQUE;
      return;
    }

    this.checkNumberUniqueness(trimmedNumber);
  }

  applyNumber(): void {
    if (!this.isFormValid()) {
      return;
    }
    
    const result: EditNumberResult = {
      isSuccess: true,
      newNumber: this.getTrimmedNumber()
    };
    
    this.activeModal.close(result);
  }

  cancel(): void {
    this.activeModal.dismiss(MODAL_DISMISS_REASONS.CANCEL);
  }

  isFormValid(): boolean {
    const trimmedNumber = this.getTrimmedNumber();
    const validation = this.validationService.validateNumber(trimmedNumber);
    return validation.isValid && this.successMessage !== '';
  }

  private resetMessages(): void {
    this.isLoading = false;
    this.errorMessage = '';
    this.successMessage = '';
  }

  private getTrimmedNumber(): string {
    return this.newNumber ? this.newNumber.trim() : '';
  }

  private isNumberUnchanged(trimmedNumber: string): boolean {
    return trimmedNumber === this.currentNumber;
  }

  private checkNumberUniqueness(trimmedNumber: string): void {
    this.isLoading = true;

    this.subscription = this.adminService.checkStandardNumberUniqueness(trimmedNumber).subscribe(
      (response: any) => this.handleUniquenessResponse(response),
      () => this.handleUniquenessError()
    );
  }

  private handleUniquenessResponse(response: any): void {
    this.isLoading = false;
    
    if (response.status === 200) {
      const isUnique = response.body;
      this.setUniquenessMessage(isUnique);
    }
  }

  private handleUniquenessError(): void {
    this.isLoading = false;
    this.errorMessage = VALIDATION_MESSAGES.ERROR_CHECKING_NUMBER;
    this.successMessage = '';
  }

  private setUniquenessMessage(isUnique: boolean): void {
    if (isUnique) {
      this.successMessage = VALIDATION_MESSAGES.NUMBER_IS_UNIQUE;
      this.errorMessage = '';
    } else {
      this.errorMessage = VALIDATION_MESSAGES.NUMBER_MUST_BE_UNIQUE;
      this.successMessage = '';
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-eight/edit-standard-number-popup/edit-standard-number-popup.component.ts